import * as Colors from './colors';
export default {
  type: 'dark',
  primary: Colors.blue700,
  secondary: Colors.pinkA200,
  success: Colors.green,
  warning: Colors.yellow600,
  info: Colors.blue,
  error: Colors.red,
  track: Colors.grey600,
  text: {
    primary: Colors.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    alternate: '#303030',
    disabled: 'rgba(255, 255, 255, 0.3)',
    hint: 'rgba(255, 255, 255, 0.3)' // 提示文字颜色
  },
  divider: 'rgba(255, 255, 255, 0.3)',
  background: {
    paper: Colors.grey800,
    chip: Colors.grey700,
    default: '#303030'
  }
};



// WEBPACK FOOTER //
// ./src/muse-ui/theme/dark.js